import ReactTableGeneric from "Components/ReactTableGeneric";
import React, { useMemo } from "react";
import Tippy from "@tippyjs/react";
import { Card, CardBody } from "reactstrap";
import { ReactComponent as PDFIcon } from "../../../../../assets/utils/images/svgs/PDF.svg";
import { ReactComponent as DocumentsIcon } from "../../../../../assets/utils/images/svgs/Documents-Icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/utils/images/svgs/Delete.svg";
import { downloadBase64File } from "../helpers";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useDocumentenContext } from "./context/DocumentenContext";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";
import { useDeleteVervangerDoc, useMoveDocument } from "Api/Coordinator/Gebruikers/Common/Document";


const SubstituteTable = () => {
	const { subsTableList: data } = useDocumentenContext();
	const { filterCommunity, currentUser, fetchUserDetails } = useGebruikerContext();
	const [showAlert, setShowAlert] = useState({
		state: false,
		documentData: "",
	});
	const community = filterCommunity[0];
	const { trigger: deleteVervangerDoc } = useDeleteVervangerDoc();
	const { trigger: documentMove } = useMoveDocument();

	const deleteDocument = async (doc) => {
		const property = doc.VvVerloopDatum ? "verloopdatum" : "";

		try {
			const response = await deleteVervangerDoc({
				url: `gebruiker/deleteUserDocument/${doc.ViDocId}`,
				data: {
					iDocTypeId: doc.iDocType,
					iAdminId: currentUser.data.clooserId,
					iCommunityId: community.iCommunityId,
					property,
				},
			});

			if (response?.status) {
				console.log("Document deleted successfully");
				fetchUserDetails();
			} else {
				console.log("Failed to delete document");
			}
		} catch (error) {
			console.error("API error:", error);
		} finally {
			setShowAlert({ state: false, documentData: "" });
		}
	};

	const moveDocumentHandler = async (rowData) => {
		try {
			const response = await documentMove({

				data: {
					iAdminId: currentUser.data.clooserId,
					iCommunityId: community.iCommunityId,
					iDocId: rowData.ViDocId,
				}
			});

			if (response?.status) {
				fetchUserDetails();
			}
		} catch (error) {
			console.error("API error:", error);
		}
	};

	const columns = useMemo(
		() => [
			{
				header: () => "Document",
				accessorKey: "Label",
			},
			{
				header: () => "Uploaddatum",
				accessorKey: "ViUpload",
			},
			{
				header: () => "Verloopdatum",
				accessorKey: "VvVerloopDatum",
				cell: (value) => value.row.original.VvVerloopDatum || "-",
			},
			{
				header: () => "Acties",
				accessorKey: "action",
				cell: (value) => (
					<div className="d-flex gap-3">
						<Tippy content="Document Openen">
							<PDFIcon
								className="cursor-pointer"
								onClick={() => {
									downloadBase64File(
										value.row.original.VvDocHref,
										value.row.original.Label
									);
								}}
							/>
						</Tippy>
						<Tippy content="Document kopieren naar bestuur">

							<DocumentsIcon
								className="cursor-pointer"
								onClick={() => {
									moveDocumentHandler(value.row.original);

								}}
							/>
						</Tippy>
						<Tippy content="Document verwijderen">
							<DeleteIcon
								className="cursor-pointer"
								onClick={() =>
									setShowAlert({ state: true, documentData: value.row.original })
								}
							/>
						</Tippy>
					</div>
				),
			},
		],
		[]
	);

	return (
		<Card className="main-card pb-5">
			<CardBody className="d-flex flex-column">
				<h5 className="mb-4">Toegevoegd door vervanger</h5>
				<ReactTableGeneric
					data={data}
					columns={columns}
					tableClassName="mb-0 table table-borderless table-sm table-hover"
					filters={{ search: false, pagination: false, sorting: false }}
				/>
			</CardBody>
			<SweetAlert
				title="Weet u zeker dat u dit document wilt verwijderen? "
				show={showAlert.state}
				type="warning"
				onConfirm={() => {
					deleteDocument(showAlert.documentData);
					setShowAlert({ state: false, documentData: "" })

				}}
				onCancel={() => setShowAlert({ state: false, documentData: "" })}
				cancelBtnText="Nee"
				confirmBtnText="Ja"
				showCancel={true}
			/>
		</Card>
	);
};

export default SubstituteTable;
